const _ = require('lodash')

const formats = require('./createFormats').createFormatsSchema()
const shared = require('../wixShared.json')
const {convertIdToAbsoluteUrn} = require('./convertIdToAbsoluteUrn')

const COMMON = {
    $id: 'common.json',
    ...formats,
    ...shared
}

const WIX_REFERENCE_ANNOTATION_PROPS = [
    'shouldCollect',
    'isRefOwner',
    'shouldValidate',
    'referencedMap',
    'isRelationalSplit',
    'dontSerialize'
]

const ALL_ANNOTATIONS = WIX_REFERENCE_ANNOTATION_PROPS.concat([
    'isTopLevelDataNode',
    '_wixReference',
    'pseudoType',
    'refTypes',
    'isPermanentDataNode',
    'variableOptions'
])

const STRONG_WIX_REFERENCE_ANNOTATIONS = {
    shouldCollect: true,
    shouldValidate: true,
    referencedMap: '#'
}

const WEAK_WIX_REFERENCE_ANNOTATIONS = {
    shouldCollect: false,
    shouldValidate: true,
    referencedMap: '#'
}

const REQUIRED_ANNOTATIONS = _.keys(STRONG_WIX_REFERENCE_ANNOTATIONS)

/**
 * @param {*} node
 * @returns {*}
 */
function getReferenceAnnotations(node) {
    return _.pick(node, WIX_REFERENCE_ANNOTATION_PROPS)
}

/**
 * @param {string} name
 * @returns {string}
 */
function createRefToCommon(name) {
    if (!_.has(COMMON, name)) {
        throw new Error(`common.json does not have ${name}`)
    }
    return convertIdToAbsoluteUrn(`common.json#/${name}`)
}

/**
 * @param {*} node
 * @returns {boolean}
 */
function isWixReference(node) {
    return _.get(node, ['_wixReference'], false)
}

/**
 * @param {*} dataType
 * @param {*} dataNodeRef
 * @param {*} variableConnections
 * @returns {*}
 */
function combineDataTypeWithDataNode(dataType, dataNodeRef, variableConnections) {
    const allOf = []

    if (variableConnections) allOf.push(variableConnections)
    allOf.push({$ref: dataNodeRef})
    allOf.push(dataType)

    return {allOf}
}

/**
 * @param {*} value
 * @returns {boolean}
 */
function isPrimitive(value) {
    const functions = [_.isNull, _.isUndefined, _.isBoolean, _.isNumber, _.isString]
    return functions.some(f => f(value) === true)
}

/**
 * @param {*} node
 * @returns {*}
 */
function removeAllAnnotations(node) {
    if (isPrimitive(node)) {
        return node
    }
    if (_.isArray(node)) {
        return node.map(removeAllAnnotations)
    }
    if (!_.isPlainObject(node)) {
        throw new Error(
            `Illegal state or input: Expected a plain object in this point of annotation removal. Got: ${node}`
        )
    }
    const recursiveResult = _.mapValues(node, (v, k) => {
        if (k === 'properties') {
            return _.mapValues(v, removeAllAnnotations)
        }
        return removeAllAnnotations(v)
    })
    return _.omit(recursiveResult, ALL_ANNOTATIONS)
}

module.exports = {
    isPrimitive,
    isWixReference,
    createRefToCommon,
    combineDataTypeWithDataNode,
    getReferenceAnnotations,
    removeAllAnnotations,
    WIX_REFERENCE_ANNOTATION_PROPS,
    STRONG_WIX_REFERENCE_ANNOTATIONS,
    WEAK_WIX_REFERENCE_ANNOTATIONS,
    REQUIRED_ANNOTATIONS,
    COMMON
}
